// extracted by mini-css-extract-plugin
export default {"root":"cross-mixing-header_root___jkXM","headInput":"cross-mixing-header_headInput__gB0RS","actionButton":"cross-mixing-header_actionButton__i0f4U"};